import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../../assets/svg/close-modal.svg";
import { Container, Row, Col } from "react-bootstrap";
import "../../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
import SearchWithAPI from "../../common/searchbox/searchbox.js";
import AsyncSelect from "react-select/async";
import { createGateApi, getEmployeeListApi } from "../../modal-dialog/setup-api.js";
import { getGateDetailsApi, updateGateApi } from "./gatemasterlist-api.js";
// import { MapContainer, TileLayer, Marker, Circle, useMapEvents } from "react-leaflet";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";

// // Fix for default marker icon in Leaflet with webpack
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
//   iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
//   shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
// });

// // Map click handler component
// const LocationMarker = ({ position, setPosition }) => {
//   useMapEvents({
//     click(e) {
//       setPosition(e.latlng);
//     },
//   });

//   return position ? <Marker position={position} /> : null;
// };
const GateCreateModal = ({ gateId, onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

  const [inDuration, setInDuration] = useState("");
  const [outDuration, setOutDuration] = useState("");

  const [lastInKey, setLastInKey] = useState("");
  const handleInChange = (event) => {
    const inputText = event.target.value;
    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
      console.log(event.key);
      if (lastInKey === "Backspace") {
        setInDuration(inputText);
      } else {
        setInDuration(inputText.length === 2 ? inputText + ":" : inputText);
      }
    }
  };

  const [lastOutKey, setLastOutKey] = useState("");
  const handleOutChange = (event) => {
    const inputText = event.target.value;
    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
      console.log(event.key);
      if (lastOutKey === "Backspace") {
        setOutDuration(inputText);
      } else {
        setOutDuration(inputText.length === 2 ? inputText + ":" : inputText);
      }
    }
  };

  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "0px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "618px",
      height: "100vh",
      overflowY: "auto",
    },
  };

  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [locationOption, setLocationOption] = useState(null);
  const [assignToOptions, setAssignToOptions] = useState(null);
  const [responsiblePersonOption, setResponsiblePersonOption] = useState(null);
  const [shift, setShift] = useState("Day Shift");
  const [openingTime, setOpeningTime] = useState("");
  const [closingTime, setClosingTime] = useState("");
  const [proofMandatoryChecked, setProofMandatoryChecked] = useState(false);
  const [checklistMandatoryChecked, setChecklistMandatoryChecked] = useState(false);
  const [otpMandatoryChecked, setOTPMandatoryChecked] = useState(false);
  const [separateQRGateOut, setSeparateQRGateOut] = useState(false);
  const [expiryDate, setexpiryDate] = useState(false);
  const [enableAttendance, setEnableAttendance] = useState(false);
  const [autoGatein, setAutoGatein] = useState(false);
  // const [autoGateinChecked, setAutoGateinChecked] = useState(false);
  // const [enableAttendanceChecked, setEnableAttendanceChecked] = useState(false);
  const [scanRequiredGateOut, setScanRequiredGateOut] = useState(false);
  // const [latitude, setLatitude] = useState("");
  // const [longitude, setLongitude] = useState("");
  // const [radius, setRadius] = useState("");
  // const [showMapPicker, setShowMapPicker] = useState(false);
  // const [mapPosition, setMapPosition] = useState(null);

  // // Update lat/lng when map position changes
  // useEffect(() => {
  //   if (mapPosition) {
  //     setLatitude(mapPosition.lat.toFixed(6));
  //     setLongitude(mapPosition.lng.toFixed(6));
  //   }
  // }, [mapPosition]);

  // // Initialize map position from existing coordinates
  // useEffect(() => {
  //   if (latitude && longitude && !mapPosition) {
  //     const lat = parseFloat(latitude);
  //     const lng = parseFloat(longitude);
  //     if (!isNaN(lat) && !isNaN(lng)) {
  //       setMapPosition({ lat, lng });
  //     }
  //   }
  // }, [latitude, longitude]);
  useEffect(() => {
    if (gateId != null) {
      getGateDetails();
    }
  }, []);

  const [validations, setValidations] = useState({
    code: "",
    gatename: "",
    location_id: "",
    responsible_person: "",
    shift: "",
    assignee: "",
    opening_gate_time: "",
    closing_gate_time: "",
    proof_mandatory: "",
    checklist_mandatory: "",
    otp_mandatory: "",
    diff_out_qr: "",
    scan_req_out: "",
    in_duration: "",
    latitude: "",
    longitude: "",
    radius: "",
  });
  function convertTo12Hour(time24) {
    const [hour, minute] = time24.split(":");
    const h = parseInt(hour);
    const suffix = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12; // convert 0 to 12
    const formattedHour = hour12.toString().padStart(2, "0");
    const formattedMinute = minute.toString().padStart(2, "0");
    return `${formattedHour}:${formattedMinute} ${suffix}`;
  }
  const convertTo24Hour = (time12h) => {
    if (!time12h) return ""; // Handle empty or null inputs by returning an empty string

    const [time, modifier] = time12h.split(" ");
    if (!time || !modifier) return ""; // If time or modifier is missing, return empty string

    let [hours, minutes] = time.split(":");
    hours = parseInt(hours, 10);

    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  };

  const getGateDetails = async () => {
    try {
      const response = await getGateDetailsApi(gateId);
      if (response.status === true) {
        console.log(response);
        var gateDetails = response.Gate_Master;
        console.log(gateDetails);
        setCode(gateDetails.code ?? "");
        setName(gateDetails.gatename ?? "");
        setLocationOption({ value: gateDetails.location_id ?? "", label: gateDetails.location ?? "" });
        setResponsiblePersonOption({ value: gateDetails.responsible_person_id ?? "", label: gateDetails.responsible_person ?? "" });
        setShift(gateDetails.shift ?? "");
        setAssignToOptions(gateDetails.assignee?.map((item) => ({ value: String(item.id), label: String(item.first_name) })));
        setOpeningTime(convertTo24Hour(gateDetails.opening_gate_time ?? ""));
        setClosingTime(convertTo24Hour(gateDetails.closing_gate_time ?? ""));
        setProofMandatoryChecked(gateDetails.proof_mandatory ?? false);
        setChecklistMandatoryChecked(gateDetails.checklist_mandatory ?? false);
        setOTPMandatoryChecked(gateDetails.otp_mandatory ?? false);
        setSeparateQRGateOut(gateDetails.diff_out_qr ?? false);
        setScanRequiredGateOut(gateDetails.scan_req_out ?? false);
        setexpiryDate(gateDetails.expiry_date ?? false);
        setAutoGatein(gateDetails.vehicle_auto_gatein ?? false);
        setEnableAttendance(gateDetails.nexus_attendance ?? false);
        setInDuration(gateDetails.in_duration ?? "");
        setOutDuration(gateDetails.out_duration ?? "");
        // setLatitude(gateDetails.latitude ?? "");
        // setLongitude(gateDetails.longitude ?? "");
        // setRadius(gateDetails.radius ?? "");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const submitGate = async (shiftValue) => {
    const dataBeforeSanitize = {
      id: gateId != null ? gateId : "",
      code: code,
      gatename: name,
      location_id: locationOption != null ? locationOption.value : "",
      responsible_person: responsiblePersonOption != null ? responsiblePersonOption.value : "",
      shift: shiftValue,
      assignee: assignToOptions?.filter((item) => item.value !== "").map((item) => item.value),
      opening_gate_time: openingTime !== "" ? convertTo12Hour(openingTime) : "",
      closing_gate_time: closingTime !== "" ? convertTo12Hour(closingTime) : "",
      proof_mandatory: proofMandatoryChecked,
      checklist_mandatory: checklistMandatoryChecked,
      otp_mandatory: otpMandatoryChecked,
      diff_out_qr: separateQRGateOut,
      scan_req_out: scanRequiredGateOut,
      expiry_date: expiryDate,
      nexus_attendance: enableAttendance,
      vehicle_auto_gatein: autoGatein,
      in_duration: inDuration,
      out_duration: outDuration,
      // latitude: latitude,
      // longitude: longitude,
      // radius: radius,
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (gateId == null) {
      const response = await createGateApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            gatename: "",
            location_id: "",
            responsible_person: "",
            shift: "",
            assignee: "",
            opening_gate_time: "",
            closing_gate_time: "",
            proof_mandatory: "",
            checklist_mandatory: "",
            otp_mandatory: "",
            diff_out_qr: "",
            scan_req_out: "",
            nexus_attendance: "",
            vehicle_auto_gatein: "",
            in_duration: "",
            out_duration: "",
            latitude: "",
            longitude: "",
            radius: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateGateApi(dataAfterSanitize, gateId);

      if (response.status === 200) {
        if (response.data.status === true) {
          onSuccess(response.data);
        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            code: "",
            gatename: "",
            location_id: "",
            responsible_person: "",
            shift: "",
            assignee: "",
            opening_gate_time: "",
            closing_gate_time: "",
            proof_mandatory: "",
            checklist_mandatory: "",
            otp_mandatory: "",
            diff_out_qr: "",
            scan_req_out: "",
            vehicle_auto_gatein: "",
            nexus_attendance: "",
            in_duration: "",
            out_duration: "",
            latitude: "",
            longitude: "",
            radius: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };

  const handleLocationDropdownChange = (option) => {
    console.log(option);
    setLocationOption(option);
  };

  const handleResponsiblePersonDropdownChange = (option) => {
    console.log(option);
    setResponsiblePersonOption(option);
  };

  const handleAssignToDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    setAssignToOptions(selectedOptions);
  };
  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const fetchOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const response = await getEmployeeListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value), // Ensure value is a string
            label: String(item.label), // Ensure label is a string
          }));
          callback(options); // Pass data to react-select
        }
      }
    }, 1000);
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>
          <div className="modal-header style-justify-between">
            <div className="add-item-modal-title">{gateId != null ? "Edit " : "Add "} gate</div>
            <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
          </div>

          <div style={{ padding: "16px 24px" }}>
            <Row style={{ width: "580px" }}>
              <Col xs={12} sm={12} md={6}>
                <div className="field-title">
                  Code<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-2 w-100"
                  value={code}
                  onChange={(event) => {
                    setCode(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error">{validations.code}</span>
              </Col>
              <Col xs={12} sm={12} md={6}>
                <div className="field-title">
                  Name<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-2 w-100"
                  value={name}
                  onChange={(event) => {
                    setName(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error">{validations.gatename}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2">
                <div className="field-title mb-2">
                  Location<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={adminApiUrl + "get_location"} params={{ checklist_type: "" }} placeholder={"Select"} selectedOption={locationOption} />
                <span className="field-error">{validations.location_id}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2">
                <div className="field-title">Shift</div>
                <select
                  className="select3 w-100 input-field mt-2"
                  id="shift"
                  value={shift}
                  onChange={(event) => {
                    setShift(event.target.value);
                  }}
                  style={{ cursor: "pointer", fontSize: "14px", fontWeight: "500", lineHeight: "18.9px", color: "#8790A1", height: "40px", borderRadius: "10px", border: "0.7px solid #E5E5E5", padding: "0 8px", gap: "77px", backgroundColor: "#FFFFFF" }}
                >
                  <option value="Day Shift">Day Shift</option>
                  <option value="Night Shift">Night Shift</option>
                </select>
                <span className="field-error">{validations.shift}</span>
              </Col>
              <Col xs={12} sm={12} md={12} className="mt-2">
                <div className="field-title mb-2">
                  Responsible Person<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <SearchWithAPI onDropdownChange={handleResponsiblePersonDropdownChange} apiUrl={adminApiUrl + "get_employee"} params={{}} placeholder={"Select"} selectedOption={responsiblePersonOption} />
                <span className="field-error">{validations.responsible_person}</span>
              </Col>

              <Col xs={12} sm={12} className="mt-2">
                <div className="field-title mb-2">
                  Assign To<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <AsyncSelect
                  isMulti
                  cacheOptions
                  value={assignToOptions}
                  loadOptions={fetchOptions}
                  onChange={(selectedOptions) => {
                    handleAssignToDropdownChange(selectedOptions);
                  }}
                  defaultOptions
                  placeholder="Search email..."
                  styles={multiselectCustomStyles}
                  isClearable={false}
                />
                <span className="field-error">{validations.assignee}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2">
                <div style={{ paddingTop: "6px", paddingBottom: "6px", display: "flex", alignItems: "center", justifyContent: "start", fontSize: "13px", fontWeight: "500", color: "#212129", marginTop: "10px" }}>In Duration</div>
                <input type="text" className="input-field" style={{ width: "100%" }} value={inDuration} onChange={handleInChange} onKeyDown={(e) => setLastInKey(e.key)} placeholder="HH:MM" />
                <span style={{ fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.in_duration}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2">
                <div style={{ paddingTop: "6px", paddingBottom: "6px", display: "flex", alignItems: "center", justifyContent: "start", fontSize: "13px", fontWeight: "500", color: "#212129", marginTop: "10px" }}>Out Duration</div>
                <input type="text" className="input-field" style={{ width: "100%" }} value={outDuration} onChange={handleOutChange} onKeyDown={(e) => setLastOutKey(e.key)} placeholder="HH:MM" />
                <span style={{ fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.out_duration}</span>
              </Col>

              <Col xs={12} sm={12} md={6} className="mt-2">
                <div className="field-title">Opening Gate Time</div>
                <input
                  type="time"
                  placeholder="Enter here"
                  className="input-field mt-2 w-100"
                  value={openingTime}
                  onChange={(event) => {
                    setOpeningTime(event.target.value);
                  }}
                />
                <span className="field-error">{validations.opening_gate_time}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-2">
                <div className="field-title">Closing Gate Time</div>
                <input
                  type="time"
                  placeholder=" "
                  className="input-field mt-2 w-100"
                  value={closingTime}
                  onChange={(event) => {
                    setClosingTime(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error">{validations.closing_gate_time}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={proofMandatoryChecked}
                    onChange={(event) => {
                      setProofMandatoryChecked(event.target.checked);
                    }}
                  />
                  <span className="field-title"> Proof Mandatory</span>
                </label>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={checklistMandatoryChecked}
                    onChange={(event) => {
                      setChecklistMandatoryChecked(event.target.checked);
                    }}
                  />
                  <span className="field-title"> Checklist Mandatory</span>
                </label>
              </Col>

              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={otpMandatoryChecked}
                    onChange={(event) => {
                      setOTPMandatoryChecked(event.target.checked);
                    }}
                  />
                  <span className="field-title"> OTP Mandatory</span>
                </label>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={separateQRGateOut}
                    onChange={(event) => {
                      setSeparateQRGateOut(event.target.checked);
                    }}
                  />
                  <span className="field-title"> Separate QR for Gate Out</span>
                </label>
              </Col>

              {/* <div style={{ paddingTop: "6px", paddingBottom: "6px", display: "flex", alignItems: "center", justifyContent: "start", fontSize: "13px", fontWeight: "500", color: "#212129", marginTop: "10px" }}>Duration</div>
              <input type="text" className="input-field" style={{ width: "100%" }} value={duration} onChange={handleChange} onKeyDown={(e) => setLastKey(e.key)} placeholder="HH:MM" />
              <span style={{ fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{validations.duration}</span> */}

              <Col xs={12} sm={12} md={5} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={scanRequiredGateOut}
                    onChange={(event) => {
                      setScanRequiredGateOut(event.target.checked);
                    }}
                  />
                  <span className="field-title"> Scan Required for Gate Out</span>
                </label>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={expiryDate}
                    onChange={(event) => {
                      setexpiryDate(event.target.checked);
                    }}
                  />
                  <span className="field-title"> Expiry Date</span>
                </label>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={enableAttendance}
                    onChange={(event) => {
                      setEnableAttendance(event.target.checked);
                    }}
                  />
                  <span className="field-title"> Enable Attendance</span>
                </label>
              </Col>

              <Col xs={12} sm={12} md={4} className="mt-2">
                <label>
                  <input
                    type="checkbox"
                    checked={autoGatein}
                    onChange={(event) => {
                      setAutoGatein(event.target.checked);
                    }}
                  />
                  <span className="field-title"> Auto Gate in (Vehicle)</span>
                </label>
              </Col>
              {/* Geofencing Fields */}

              Geofencing Section
              {/* <Col xs={12} sm={12} md={12} className="mt-3">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                  <div className="field-title" style={{ fontWeight: "600", fontSize: "14px" }}>
                    Geofencing Location
                  </div>
                  <div
                    onClick={() => setShowMapPicker(!showMapPicker)}
                    style={{
                      cursor: "pointer",
                      padding: "6px 12px",
                      backgroundColor: showMapPicker ? "#dc3545" : "#2c8c53",
                      color: "#fff",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "500",
                      transition: "background-color 0.2s",
                    }}
                  >
                    {showMapPicker ? "Hide Map" : "Pick from Map"}
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={12} md={4} className="mt-2">
                <div className="field-title">Latitude</div>
                <input
                  type="text"
                  placeholder="Enter latitude"
                  className="input-field mt-2 w-100"
                  value={latitude}
                  onChange={(event) => {
                    setLatitude(event.target.value);
                    const lat = parseFloat(event.target.value);
                    const lng = parseFloat(longitude);
                    if (!isNaN(lat) && !isNaN(lng)) {
                      setMapPosition({ lat, lng });
                    }
                  }}
                />
                <span className="field-error">{validations.latitude}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <div className="field-title">Longitude</div>
                <input
                  type="text"
                  placeholder="Enter longitude"
                  className="input-field mt-2 w-100"
                  value={longitude}
                  onChange={(event) => {
                    setLongitude(event.target.value);
                    const lat = parseFloat(latitude);
                    const lng = parseFloat(event.target.value);
                    if (!isNaN(lat) && !isNaN(lng)) {
                      setMapPosition({ lat, lng });
                    }
                  }}
                />
                <span className="field-error">{validations.longitude}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-2">
                <div className="field-title">Radius (meters)</div>
                <input
                  type="text"
                  placeholder="Enter radius"
                  className="input-field mt-2 w-100"
                  value={radius}
                  onChange={(event) => {
                    setRadius(event.target.value);
                  }}
                />
                <span className="field-error">{validations.radius}</span>
              </Col> */}

              {/* Map Picker - Below input fields */}
              {/* {showMapPicker && (
                <Col xs={12} sm={12} md={12} className="mt-3">
                  <div style={{ height: "300px", width: "100%", borderRadius: "10px", overflow: "hidden", marginBottom: "15px", border: "1px solid #E5E5E5" }}>
                    <MapContainer center={mapPosition || { lat: 13.0827, lng: 80.2707 }} zoom={mapPosition ? 15 : 12} style={{ height: "100%", width: "100%" }}>
                      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                      <LocationMarker position={mapPosition} setPosition={setMapPosition} />
                      {mapPosition && radius && <Circle center={mapPosition} radius={parseFloat(radius) || 100} pathOptions={{ color: "#007bff", fillColor: "#007bff", fillOpacity: 0.2 }} />}
                    </MapContainer>
                    <div style={{ fontSize: "11px", color: "#8790A1", marginTop: "5px" }}>Click on the map to set the gate location</div>
                  </div>
                </Col>
              )} */}
            </Row>

            <Row className="mt-3" style={{ width: "580px" }}>
              <div className="style-justify-end">
                <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                  Cancel
                </div>
                <div
                  className="save-modal-btn style-justify-center"
                  onClick={(e) => {
                    const currentShift = shift === "Day Shift" || shift === "" ? "Day Shift" : shift;
                    setShift(currentShift);
                    submitGate(currentShift);
                  }}
                >
                  {gateId != null ? "Update " : "Save "}
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GateCreateModal;
